import * as z from "zod";
import { vm } from "../../../../shared/utils/validationMessages";

export const formSchema = z.object({
  name: z.string().min(1, { message: vm.NAME_REQUIRED }),
  building_tower: z.string().min(1, { message: vm.TOWER_REQUIRED }),
  building_apartment: z.string().min(1, { message: vm.APARTMENT_REQUIRED }),
  swimmer_type_id: z.string().min(1, { message: vm.SWIMMER_TYPE_REQUIRED }),
  // Optional registration timestamp (admin-only field, no extra validation here)
  registration_timestamp: z.string().optional(),
});

export type EditSwimmerFormData = z.infer<typeof formSchema>;

export interface UseEditSwimmerFormProps {
  onSubmit: (data: EditSwimmerFormData) => void;
  initialData?: Partial<EditSwimmerFormData>;
  /** Initial registration timestamp ISO string (from backend) */
  initialRegistrationTimestamp?: string | null;
  /** Callback to notify parent of registration timestamp changes (ISO string or null) */
  onRegistrationTimestampChange?: (value: string | null) => void;
}
